export default __webpack_public_path__ + "static/erp-white-af5e44558f6e37f746258030cd04b83d.svg";